import { PrimaryButton, Stack, Text } from '@fluentui/react';

import { postAsync } from '../../../utils/api';
import { setFormsActiveAccount } from '../../Forms/slice/newFormReducers';
import ReturnableText from '../../ReturnableText';
import { actions } from '../slice';
import AccountForm from './Components/AccountForm';
import getFormData from './Components/get-form-data';

const SubmitButton = (props: { disabled: boolean }) => {
  return (
    <PrimaryButton text="Ekle" onClick={submit} disabled={props.disabled} />
  );
};

export default () => {
  return (
    <Stack tokens={stackTokens}>
      <Text variant="large">
        <ReturnableText text="Hesap Ekle" onClick={actions.reset} />
      </Text>
      <AccountForm buttons={SubmitButton} />
    </Stack>
  );
};

const stackTokens = { childrenGap: 15 };
const submit = async () => {
  actions.setSubmitDisabled(true);

  const data = await getFormData();

  if (!data) {
    actions.setSubmitDisabled(false);
    return;
  }

  const submitRes = await postAsync("/accounts/new", data);

  if (!(submitRes.success && submitRes.id && submitRes.versionId)) {
    alert("Hata hesap eklenemedi");
    return;
  }

  actions.reset();
  actions.setActiveAccountId(submitRes.id);

  setFormsActiveAccount(submitRes.id, submitRes.versionId);
};
